export const environment = {
  production: false,
  
  apiUrl: 'https://vvd-dev.intentio.co.za/api',
  
};
